import { mediaQuery } from 'constants/ui';
import { getConditionalObject } from 'utils/data';

export const cardWrapperStyles = {
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderRadius: ({ shape }) => shape.radius.l,
  backgroundColor: ({ palette }) => palette.background.secondary,
  padding: '20px 24px',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  height: '100%',

  [mediaQuery.mobile]: {
    padding: '16px',
    gap: '16px',
  },
};

export const fieldsStyles = {
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: '16px',
};

export const fieldRowStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '16px',
};

export const fieldVerticalRowStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const getFieldValueStyles = isVertical => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  minWidth: 0,
  ...getConditionalObject(!isVertical, {
    textAlign: 'right',
  }),
});
